import React from "react";
import { Button, Image, Icon, Modal } from "semantic-ui-react";
import PropTypes from "prop-types";
import { split } from "lodash";
// Redux
import { connect } from "react-redux";

// Components

// Styles
import styles from "./styles.module.css";

// formats

const ImageView = ({ fileImage, onClose }) => {
	const url = (img) => {
		const blobString = split(img, ":");
		if (blobString[0] === "blob") {
			return img;
		}
		return `${import.meta.env.VITE_API_URL}/${img}`;
	};
	return (
		<div>
			<Modal
				basic
				onClose={() => {
					onClose();
				}}
				open
				size="small"
				closeIcon>
				<Modal.Content className={styles.modalContectImg}>
					<Image src={url(fileImage)} size="medium" rounded />
				</Modal.Content>
				<Modal.Actions>
					<Button
						basic
						color="red"
						inverted
						onClick={() => {
							onClose();
						}}>
						<Icon name="remove" /> Atrás
					</Button>
				</Modal.Actions>
			</Modal>
		</div>
	);
};

function mapStateToProps({ user, tags }) {
	return {
		user,
		tags,
	};
}

ImageView.propTypes = {
	fileImage: PropTypes.array,
	onClose: PropTypes.func,
};

export default connect(mapStateToProps)(ImageView);
